export { installmentListScreen, installmentDetailScreen } from './installment.screen';
export { installmentListSearch, installmentDetailSearch } from './installment.search';
export { loadInstallmentMessages } from './installment.catalog';
export const loadInstallmentScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadInstallmentGuides = () => import('./installment.guide');
